
import {
  TypographyElement,
  Container,
  Button,
  ButtonVariation,
  Icon,
  Icons,
  Row,
  AdCardCpf,
  Col,
  ButtonSize
} from 'UI/'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'
import { illustrationCPF } from 'assets'
import { ExternalAlphormPages } from 'constants/'
import { decorateUrl } from 'components/common/UTMscript'
import { PreSignupPath } from 'navigation/Routes'

const useStyles = createUseStyles(style)

export default ({ isFrance, signup, isElligableForTrial, isAlgeria }) => {
  const theme = useTheme()
  const {
    container,
    imageStyle,
    paper,
    column,
    iconStyle,
    rowStyle,
    leftMotif,
    rightMotif
  } = useStyles()
  return (
    <Container className={container}>
      <TypographyElement
        alignTablet='left'
        alignMobile='left'
        variant='heading2'
        Component='h2'
        spacing='0 0 24px 0'
      >
        {Text.title}
      </TypographyElement>
      {
        isFrance
          ? (
            <div className={paper}>
              <div className={leftMotif} />
              <div className={rightMotif} />
              <object type='image/svg+xml' data={illustrationCPF} className={imageStyle} title='hero Illustration'>CPF Illustration</object>
              <div className={column}>
                <TypographyElement
                  variant='heading3'
                  Component='h3'
                  spacing='0 0 8px 0'
                  spacingTablet='0 0 16px 0'
                  spacingMobile='0 0 16px 0'
                >
                  {Text.title1}
                </TypographyElement>
                <TypographyElement
                  variant='body1'
                  spacing='0 0 9px 0'
                >
                  {Text.subtitle}
                </TypographyElement>
                <div>
                  {
                    Text.infos.map((info, index) => (
                      <div key={index} className={rowStyle}>
                        <Icon iconName={Icons.check} style={iconStyle} />
                        <TypographyElement
                          variant='body1'
                        >
                          {info}
                        </TypographyElement>
                      </div>
                    ))
                  }
                </div>
                <Button
                  size={ButtonSize.small}
                  variation={ButtonVariation.secondary}
                  label={Text.button}
                  dataTest='CPF-button'
                  marginButton='13px 0 0 0'
                  width={252}
                  widthTablet='100%'
                  widthMobile='100%'
                  Component='a'
                  openOnNewTab
                  disablePreventDefault
                  href={decorateUrl(ExternalAlphormPages.Funding)}
                />
              </div>
            </div>
            )
          : null
      }
      <Row gap={5} tabletGap={20} mobileGap={30}>
        <Col grid={6} mgrid={12} sgrid={12} direction='column'>
          <AdCardCpf
            shadowColor={theme.warning[0]}
            title={Text.adCard1.title}
            infos={Text.adCard1.infos}
            buttonLabel={Text.adCard1.ctaText}
            href={decorateUrl(PreSignupPath)}
            isElligableForTrial={isElligableForTrial}
            onButtonClick={(e) => {
              e.preventDefault()
              signup()
            }}
          />
        </Col>
        <Col grid={6} mgrid={12} sgrid={12} direction='column'>
          <AdCardCpf
            shadowColor={theme.info[0]}
            title={Text.adCard2.title}
            infos={Text.adCard2.infos}
            buttonLabel={Text.adCard2.ctaText}
            isElligableForTrial={isElligableForTrial}
            href={decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer)}
          />
        </Col>
      </Row>
    </Container>
  )
}
